import styled from "@emotion/styled";

import MorningStudioLogo from "~/components/article/article-render/morning-studio-article/header/morning-studio-logo.svg";

export const SubheaderContainer = styled.div`
  block-size: 34px;
  margin-block-end: -34px;

  background-color: rgba(0, 0, 0, 0.6);

  ${props => props.theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const ContentContainer = styled.div`
  padding-block: 8px;
  padding-inline: 16px;
`;

export const StyledMorningStudioLogo = styled(MorningStudioLogo)`
  inline-size: 120px;
  block-size: 18px;
`;
